import { invokeModuleMethod } from './moduleRuntimeHelpers.js';

export function createReaderUiActionFacade(context = {}) {
  const {
    ensureReaderStatsModuleReady,
    getReaderStatsModuleApi,
    ensureReaderImmersiveModuleReady,
    getReaderImmersiveModuleApi,
    ensureReaderDisplayModeModuleReady,
    getReaderDisplayModeModuleApi,
    ensureReaderQuickThoughtModuleReady,
    getReaderQuickThoughtModuleApi,
    ensureReaderRenderSizingModuleReady,
    getReaderRenderSizingModuleApi,
    waitForStableElementSizeFallback,
    ensureReaderKeyboardModuleReady,
    getReaderKeyboardModuleApi,
    elements,
    closeModal,
    ensureReaderBookmarksModuleReady,
    getReaderBookmarksModuleApi,
    ensureReaderShareModuleReady,
    showToast
  } = context;

  const noOp = () => {};
  const showModuleError = (message) => {
    if (typeof showToast === 'function') {
      showToast(message);
    }
  };

  function loadReadingStats() {
    invokeModuleMethod(getReaderStatsModuleApi, ensureReaderStatsModuleReady, 'loadReadingStats', [], noOp);
  }

  function startReadingSession() {
    invokeModuleMethod(getReaderStatsModuleApi, ensureReaderStatsModuleReady, 'startReadingSession', [], noOp);
  }

  function endReadingSession() {
    invokeModuleMethod(getReaderStatsModuleApi, ensureReaderStatsModuleReady, 'endReadingSession', [], noOp);
  }

  function applyMobileReaderImmersive() {
    invokeModuleMethod(getReaderImmersiveModuleApi, ensureReaderImmersiveModuleReady, 'applyMobileReaderImmersive', [], noOp);
  }

  function toggleFullscreen() {
    invokeModuleMethod(getReaderDisplayModeModuleApi, ensureReaderDisplayModeModuleReady, 'toggleFullscreen', [], noOp);
  }

  function toggleDualPageMode() {
    invokeModuleMethod(getReaderDisplayModeModuleApi, ensureReaderDisplayModeModuleReady, 'toggleDualPageMode', [], noOp);
  }

  function openQuickThought() {
    invokeModuleMethod(
      getReaderQuickThoughtModuleApi,
      ensureReaderQuickThoughtModuleReady,
      'openQuickThought',
      [],
      () => showModuleError('思索模块加载失败')
    );
  }

  function initResizeHandler() {
    invokeModuleMethod(getReaderRenderSizingModuleApi, ensureReaderRenderSizingModuleReady, 'initResizeHandler', [], noOp);
  }

  function cleanupResizeHandler() {
    invokeModuleMethod(getReaderRenderSizingModuleApi, ensureReaderRenderSizingModuleReady, 'cleanupResizeHandler', [], noOp);
  }

  async function waitForStableElementSize(el, options = {}) {
    try {
      const mod = await ensureReaderRenderSizingModuleReady();
      if (typeof mod?.waitForStableElementSize === 'function') {
        return await mod.waitForStableElementSize(el, options);
      }
    } catch {
    }
    return waitForStableElementSizeFallback(el);
  }

  function rerenderReaderForCurrentSize() {
    invokeModuleMethod(
      getReaderRenderSizingModuleApi,
      ensureReaderRenderSizingModuleReady,
      'rerenderReaderForCurrentSize',
      [],
      noOp
    );
  }

  async function maybeFixInitialRenderSize(initialSize) {
    try {
      const mod = await ensureReaderRenderSizingModuleReady();
      await mod?.maybeFixInitialRenderSize?.(initialSize);
    } catch {
    }
  }

  function handleKeyboard(event) {
    const api = typeof getReaderKeyboardModuleApi === 'function' ? getReaderKeyboardModuleApi() : null;
    if (typeof api?.handleKeyboard === 'function') {
      api.handleKeyboard(event);
      return;
    }

    if (elements?.modalOverlay?.classList?.contains('active') && event?.key === 'Escape') {
      closeModal?.();
      return;
    }

    invokeModuleMethod(getReaderKeyboardModuleApi, ensureReaderKeyboardModuleReady, 'handleKeyboard', [event], noOp);
  }

  async function addCurrentBookmark(showPanel = false) {
    try {
      const mod = await ensureReaderBookmarksModuleReady();
      await mod?.addCurrentBookmark?.(showPanel);
    } catch {
      showModuleError('书签模块加载失败');
    }
  }

  function renderBookmarks() {
    invokeModuleMethod(getReaderBookmarksModuleApi, ensureReaderBookmarksModuleReady, 'renderBookmarks', [], noOp);
  }

  async function showShareHighlightModal(highlight) {
    try {
      const mod = await ensureReaderShareModuleReady();
      await mod?.showShareHighlightModal?.(highlight);
    } catch {
      showModuleError('分享模块加载失败');
    }
  }

  return {
    loadReadingStats,
    startReadingSession,
    endReadingSession,
    applyMobileReaderImmersive,
    toggleFullscreen,
    toggleDualPageMode,
    openQuickThought,
    initResizeHandler,
    cleanupResizeHandler,
    waitForStableElementSize,
    rerenderReaderForCurrentSize,
    maybeFixInitialRenderSize,
    handleKeyboard,
    addCurrentBookmark,
    renderBookmarks,
    showShareHighlightModal
  };
}
